module.exports = __webpack_public_path__ + "static/media/icon-comm-call.4c920c77.svg";